import type { EvaluationType, Offer, OfferAddon, PayoutType, ScalingPlan, TechnologyPlatform } from '~/types/offer'

export type UIOfferResponseResource = {
  assetGroup: {
    id: number
    name: string
    displayName: string
    enabled: boolean
  }
  payoutTypes: PayoutType[]
}

export const isCFDOffer = (response: UIOfferResponseResource) => response.assetGroup.name === 'CFD'
export const isStocksOffer = (response: UIOfferResponseResource) => response.assetGroup.name === 'Stocks'

export const getPlatformFullName = (technologyPlatform: TechnologyPlatform | undefined | null) => {
  if (!technologyPlatform) return ''

  return (
    { MT5: 'Platform 5', MT4: 'Platform 4' }[(technologyPlatform?.name as string) || ''] ||
    technologyPlatform?.displayName ||
    technologyPlatform.name
  )
}

// there will be only one offer in one of the evaluationTypes, this function finds it and if it's the CFD offer
// it builds the same structure as in quick-checkout/cfd's decisionState, that's the structure
// used in the OrderSummary for now
export type TransformedOffer = Offer & {
  assetGroup: 'CFD' | 'FUTURES' | 'STOCKS' // override parent
  payoutType: number
  evaluationType: string
  platform: TechnologyPlatform
  addons: OfferAddon[]
  scalingPlan: ScalingPlan
}
type TransformOfferResponseReturnType = {
  payoutType: PayoutType
  offer: TransformedOffer
  evaluationType: EvaluationType
} | null
export const transformOfferResponse = (
  response: UIOfferResponseResource,
  scalingPlanId: number | string,
): TransformOfferResponseReturnType => {
  const payoutTypeObject = response.payoutTypes.find((pt) => pt.evaluationTypes.find((et) => et.offers.length === 1))
  if (!payoutTypeObject) return null

  const evaluationType = payoutTypeObject?.evaluationTypes.find((et) => et.offers.length === 1)
  if (!evaluationType) return null

  let offerData = evaluationType.offers[0] // there will be only one item

  const scalingPlan = offerData.scalingPlans.find((sp) => sp.scalingPlanId === Number(scalingPlanId))

  offerData = Object.assign(offerData, {
    payoutType: payoutTypeObject.payoutType,
    evaluationType: evaluationType.evaluationType,
    platform: scalingPlan?.technology.technologyPlatform,
    addons: scalingPlan?.addons,
    scalingPlan,
  })

  return {
    payoutType: payoutTypeObject,
    offer: offerData as TransformedOffer,
    evaluationType,
  }
}
